module.exports = __webpack_public_path__ + "static/media/portfolio 8.7be81020.JPG";